import { AnyAction } from 'redux';
import { ActionDispatching } from 'app/types-shared';
import { ApplicationState } from 'app/types-store';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { isForbiddenStatus } from 'app/area/shared/actions-utils';
import {
  RequestCodetableAccess, ReceiveCodetableAccess, FailCodetableAccess,
  RequestHierarchy, ReceiveHierarchy, FailHierarchy,
  ForbiddenAccess
} from './action-types';
import { api } from './api';

export const actionCreators = {
  loadCodetableAccess: (codetableId: number): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      dispatch(new RequestCodetableAccess(codetableId));

      try {
        const result = await api.loadCodetableAccess(codetableId);
        const codetableAccess = result?.find(access => access.id === codetableId);

        dispatch(new ReceiveCodetableAccess(codetableId, codetableAccess));
      } catch (err) {
        if (isForbiddenStatus(err)) {
          dispatch(new ForbiddenAccess());
        }

        dispatch(new FailCodetableAccess(codetableId));
      }
    },

  loadHierarchy: (): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      dispatch(new RequestHierarchy());

      try {
        const result = await api.loadHierarchy();
        const hierarchyOptions = result?.rootCodes?.map(codeItemToStoreValue) ?? [];

        dispatch(new ReceiveHierarchy(hierarchyOptions));
      } catch (err) {
        if (isForbiddenStatus(err)) {
          dispatch(new ForbiddenAccess());
        }

        dispatch(new FailHierarchy());
      }
    }
};
